<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    window.onpopstate = () => {
      // if (!this.allowBack) {
      //   //    这个allowBack 是存在vuex里面的变量
      //   history.go(1);
      // }
    };
    
  }
};
</script>

<style  lang="scss">
@import "./styles/index";
@import "./assets/css/reset";
@import "./assets/css/global";
[v-cloak] {
  display: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  img {
    max-width: 100%;
  }
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volumebar-wrp .dplayer-volume-bar-vertical .dplayer-volumebar.bui.bui-slider .bui-track.bui-track-vertical .bui-bar-wrap .bui-bar:before{
  left:50% !important;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue